import { IController } from 'angular';
import * as _ from 'lodash';
import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class SafetyNetEligibilityCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  private activeStudentsByCohort;
  private studentIdsByEligibility;
  public sort;
  public activeStudentsByCohortFilter;
  public activeStudentIds;
  public activeStudentIdsFilter;
  public currentCohortFilter;
  public currentCohortFilterIncludingSuperSeniors;
  public currentCohortContainsSuperSeniors;
  public filterOptions;
  // studentIds by gradPlan -- calc and current:
  public inEligibleStudentIds: string[];
  public inEligibleStudentIdsFilter: string;
  public isSafetyNetEligibleIds: string[];
  public isSafetyNetEligibleIdsFilter: string;
  public notVerifiedSafetyNetEligibleIds: string[];
  public notVerifiedSafetyNetEligibleIdsFilter: string;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filterOptions = {
      columnKeys: [
        'iep',
        'potentiallyEligibleForSafetyNet',
        'schoolVerifiedSafetyNetEligibility',
        'isSafetyNetEligible',
      ],
      sort: [{ colId: 'studentName', sort: 'asc' }, { colId: 'potentiallyEligibleForSafetyNet', sort: 'asc' }],
    };
    this.currentCohortFilterIncludingSuperSeniors = this.WizardUtils.getCurrentCohortFilter();
    this.currentCohortFilter = _.last(this.currentCohortFilterIncludingSuperSeniors);
    this.currentCohortContainsSuperSeniors =
      Cohort[this.currentCohortFilter] && Cohort[this.currentCohortFilter].studentYear === 4;

    this.activeStudentsByCohort = this.WizardUtils.getFilteredFlattenedStudents({
      status: ['A', 'A-NDG'],
      cohort: this.currentCohortFilterIncludingSuperSeniors,
    });

    this.studentIdsByEligibility = this.generateFilteredStudentIdBuckets();
    this.activeStudentIds = this.studentIdsByEligibility.activeStudentIds;
    // bullet one
    this.isSafetyNetEligibleIds = this.studentIdsByEligibility.isSafetyNetEligibleIds;
    // bullet two
    this.notVerifiedSafetyNetEligibleIds = this.studentIdsByEligibility.notVerifiedSafetyNetEligibleIds;
    // bullet three
    this.inEligibleStudentIds = this.studentIdsByEligibility.inEligibleStudentIds;
  }

  private generateFilteredStudentIdBuckets(): object {
    const activeStudentIds = [];
    const isSafetyNetEligibleIds = [];
    const notVerifiedSafetyNetEligibleIds = [];
    const inEligibleStudentIds = [];

    _.each(this.activeStudentsByCohort, (student: any) => {
      const { studentId } = student;
      activeStudentIds.push(studentId);
      if (student.isSafetyNetEligible) isSafetyNetEligibleIds.push(studentId);

      if (student.potentiallyEligibleForSafetyNet && !student.schoolVerifiedSafetyNetEligibility) {
        notVerifiedSafetyNetEligibleIds.push(studentId);
      }
      if (!student.isSafetyNetEligible && !student.potentiallyEligibleForSafetyNet) {
        inEligibleStudentIds.push(studentId);
      }
    });

    return { activeStudentIds, isSafetyNetEligibleIds, notVerifiedSafetyNetEligibleIds, inEligibleStudentIds };
  }
}
